import { config } from '../config';
import type { IFormSelect } from '../typings';

/** Follows a chosen slot whose practice location is no longer on the application. */
export const GONE_SLOT_LABEL = 'no longer on your application';

/** Under a practice dropdown that offers no slot. */
export const NO_PRACTICE_LOCATIONS =
  'Add a practice location to choose it here.';

/** The option values a select's Formik value holds. */
export const selectValues = (value: unknown): string[] => {
  if (Array.isArray(value)) return value.map(String);
  if (typeof value !== 'string' || value === '') return [];
  return value.split(config.multiValueDivider);
};

/** The error under a practice dropdown holding a slot whose practice location is gone. */
export const GONE_SLOT_MESSAGE =
  'This office is no longer on your application. Choose another office or remove it.';

/** The option values of the select's slots that no live practice location holds. */
export const goneSlotValues = (field: IFormSelect): ReadonlySet<string> =>
  new Set(
    (field.lookupEntryAddresses ?? [])
      .filter(slot => !slot.targetFieldId && slot.optionValue !== undefined)
      .map(slot => slot.optionValue as string),
  );
